"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HighChicagoOptions = void 0;
/** HighChicagoOptions.tsx
 *
 * Game Options for HighChicago.
 */
const BetLimit_1 = require("../bets/BetLimit");
const CardVersionSetting_1 = require("../enums/CardVersionSetting");
const defaultOptions_1 = require("./defaultOptions");
exports.HighChicagoOptions = {
    versions: [
        {
            title: "7 Cards",
            description: "",
            value: CardVersionSetting_1.CardVersionSetting.SEVEN_CARD,
            default: true,
            flavor: 7,
            betLimit: BetLimit_1.BetLimit.SPREAD_LIMIT,
        },
    ],
    winners: [
        Object.assign(Object.assign({}, defaultOptions_1.winnerHighOnlyDefault), { description: "High hand splits with high spade in the hole" }),
    ],
    options: [
        defaultOptions_1.optionNoneDefault,
        Object.assign(Object.assign({}, defaultOptions_1.optionRollYourOwn), { description: "Roll Your Own (First card)" }),
    ],
    wildcards: [
        defaultOptions_1.wildcardNoneDefault,
        defaultOptions_1.wildcardLowHoleWithBuy,
        defaultOptions_1.wildcardDeuces,
        defaultOptions_1.wildcardOneEyedJacks,
    ],
};
//# sourceMappingURL=HighChicagoOptions.js.map